import { render, staticRenderFns } from "./MerchantInfoCard.vue?vue&type=template&id=1154728c&"
import script from "./MerchantInfoCard.vue?vue&type=script&lang=js&"
export * from "./MerchantInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports